import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { useAppContext } from '../context/AppContext';

export default function LegalView() {
  const { lang, t, setView, legalContent } = useAppContext();
  return (
    <div style={{ padding: '20px' }}>
      <div onClick={() => setView('profile')} style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', marginBottom: '20px' }}>
        <ChevronLeft /> <h3 style={{ margin: 0 }}>{t.rules}</h3>
      </div>
      <div style={{ background: '#fff', padding: '25px', borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.03)', whiteSpace: 'pre-wrap', lineHeight: '1.8', fontSize: '14px', color: '#444' }}>
        {lang === 'es' ? legalContent.es : legalContent.zh}
      </div>
    </div>
  );
}
